<template>
  <v-row>
    <v-col cols="12">
        <ingredient-card></ingredient-card> 
    </v-col>
  </v-row>
</template>
<script>
import IngredientCard from "@/components/ingredient/IngredientCard";

export default {
  metaInfo: {
    // title will be injected into parent titleTemplate
    title: "Ingredient List",
  },

  components: {
    IngredientCard
  },

  data() {
    return {
    };
  },
};
</script>